import { SearchInput } from '../shared';
import { SortOrder, VirtualPosSortType } from '../enums';

export class GetVirtualPosesInput extends SearchInput<VirtualPosSortType> {
    constructor() {
        super(VirtualPosSortType.Name);
        this.sortOrder = SortOrder.Ascending;
    }
}